

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/demo/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.BkDTDQeg.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/COV05J5X.js","_app/immutable/chunks/DDSnUQRm.js","_app/immutable/chunks/ZS3-Rmiz.js","_app/immutable/chunks/BfFtub1s.js","_app/immutable/chunks/qTkxire8.js","_app/immutable/chunks/CbNCDuoM.js"];
export const stylesheets = [];
export const fonts = [];
